import { Predicate } from 'effect';
import type { CaseAbility } from '@/abilities/createCaseAbility';
import type { DestinationAction, DestinationTree } from '@/abilities/destination';

/** A destination of the company workspace: the standard workspace and the confidential one. */
export type CompanyWorkspaceDestinationKey = 'standard' | 'confidential';

/** Each container's children, in landing order. Empty: no route holds both workspaces, so each is a leaf. */
export const companyWorkspaceDestinationTree: DestinationTree<CompanyWorkspaceDestinationKey> = {};

export const COMPANY_WORKSPACE_DESTINATION = 'CompanyWorkspaceDestination';

export type CompanyWorkspaceDestination = {
  readonly kind: typeof COMPANY_WORKSPACE_DESTINATION;
  readonly destination: CompanyWorkspaceDestinationKey;
};

export type CompanyWorkspaceAction = DestinationAction;

export type CompanyWorkspaceAbility = CaseAbility<CompanyWorkspaceAction, CompanyWorkspaceDestination>;

export const toCompanyWorkspaceDestination = (
  destination: CompanyWorkspaceDestinationKey,
): CompanyWorkspaceDestination => ({
  kind: COMPANY_WORKSPACE_DESTINATION,
  destination,
});

export const isCompanyWorkspaceDestination = (value: unknown): value is CompanyWorkspaceDestination =>
  Predicate.hasProperty(value, 'kind') && value.kind === COMPANY_WORKSPACE_DESTINATION;
